

















import { Component, Vue } from 'vue-property-decorator';
import Placeholder from './Placeholder.vue';
import TimeSheetList from './TimeSheetList.vue';
import { vxm } from '@/store.vuex';
@Component({
  components: {
    Placeholder,
    TimeSheetList,
  },
})
export default class TimeSheet extends Vue {
  mounted() {
    vxm.timesheet.fetchTimesheet();
  }
  onAddTimeSheet() {
    this.$bvModal.show('timesheet-entry-modal');
    vxm.timesheet.setEditTimeSheetId(0);
  }
}
